import {useState} from 'react';


const Search = (props) => {


  const filedata = require("./Tickers.json");

  const tickerdata = filedata.StockName;

  const [data, setData]  = useState(['AAPL','AMD']);

  const [value, setValue] = useState('');

    const handleChange= (e) => {

        //console.log('input ' + e.target.value) ;
        const searchItem = e.target.value.toLowerCase();
        
        // reduce the array size to reduce overhead
        if (searchItem.length  === 1) {
           
           setData(tickerdata.filter((item) => {
              const ticker = item.toLowerCase();
              return (
                 ticker.startsWith(searchItem) 
              )}));

        }
        else if (searchItem.length  === 0) {
           setData(tickerdata);
        }

        setValue(e.target.value);
    };

    const handleSearch= (searchItem) => {
      setValue('');
      if (searchItem !== ''){
         props.handler(searchItem);
      }
    };

    return ( 
        <div className="classic-search-container">
          <div className="search-box">
            <input type="text" className="search" id="comparePageFormInputStockName" placeholder="Enter stock ticker to review" value={value} onChange={handleChange} />
            <button className="btn-normal" onClick={() => handleSearch(value)}> Add Stock </button>
         </div>
         <div className="dropdown">
          { (value.length >= 2) &&
            data.filter((item) => {
            const searchItem = value.toLowerCase();
            const ticker = item.toLowerCase();
            
            return (
              searchItem && 
              ticker.startsWith(searchItem) 
            );

          })
          .slice(0, 5)
          .map((item) => (
            <div  className="dropdown-row" key={item} onClick={(() => handleSearch(item))}>
                {item}
            </div>
          ))}
          {(value.length <= 1) && <div></div>}
          </div>
         </div>
     );
}
 
export default Search;
